var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('el-input',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"size":"normal"},on:{"input":_vm.input}},[_c('img',{staticClass:"el-input__icon",attrs:{"slot":"prefix","src":require("@/assets/image/icon/search.png")},slot:"prefix"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }